<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
          <div class="col-md-12">
            <div class="alert alert-info" role="alert">
              FYI : Cara pemakaian lihat di Menu Tutorial (APK) ye. Ada tutornya di youtube. Jangan lupa subscribe akak huehehe
            </div>
          </div>
          
          <div class="col-md-8">
            <div>
              <div class="card" >
                <div class="card-body" >
                  <div class="judulBox">
                    <h4>Tutorial WABOT Lokalan</h4>
                    <button  v-show="!data.blTutorial" class="btn btn-info " @click="data.blTutorial = true">Tampilkan</button>
                  </div>
                  <div class="tutorBox mt-2" v-show="data.blTutorial">
                    <ul>
                      <li class="mb-2">
                        <div class="listing">
                          <strong class="mb-0 text-danger">DISCLAIMER : INI BUKAN SCRIPT OFFICIAL DARI WHATSAPP, INI AJA TRIK AJA BIAR BISA NGIRIM WA BOT SECARA OTOMATIS</strong>
                        </div>
                      </li>
                      <li class="mb-2">
                        <div class="listing">
                          <h3 class="m-0">MODE RA RUWET</h3>
                          <p class="m-0">Download Beatcom WABOT exe aja ya, jadi kayak nginstal software di windows.</p>
                          <a class="btn btn-success" href="http://download.beatcom.web.id/?app=wabot" target="_blank">DOWNLOAD BEATCOM WA BOT.exe</a>
                        </div>
                      </li>
                      <li class="mb-2">
                        <div class="listing">
                          <h3 class="m-0">MODE SUHU</h3>
                          <strong class="mb-0">1. Download dan Instal </strong>
                          <p class="m-0">Karena engine utamanya pake nodejs jadi instal dulu ya, di link ini. Node JS v.18.xx - <a href="https://nodejs.org/dist/v18.18.0/node-v18.18.0-x64.msi" target="_blank"><strong>https://nodejs.org/dist/v18.18.0/node-v18.18.0-x64.msi</strong></a></p>
                        </div>
                      </li>
                      <li class="mb-2">
                        <div class="listing">
                          <strong class="mb-0">2. Cek pakah sudah terinstal dengan bener </strong>
                          <p class="m-0">Buka CMD ketikan </p>
                          <strong class="script-box">node -v</strong>
                          <p class="m-0">dan Ketikan </p>
                          <strong class="script-box">npm -v</strong>
                          <p class="m-0">Jika Instalasi berhasil akan muncul seperti di ini </p>
							            <img class="icon" src="@/assets/tutorial/npm.png" alt=""> 
                          <p class="m-0">Jika tidak muncul, Monggo googling masing2 ya hehe, biasanya pencariannya "node not found" / "npm not found" windows 10/11 </p>
                        </div>
                      </li>
                      <li class="mb-2">
                        <div class="listing">
                          <strong class="mb-0 d-block">3. Download Script Wa Bot Lokalan </strong>
                          <a class="btn btn-success" href="https://admin.beatcom.web.id/wabot_lokalan.zip" target="_blank">DOWNLOAD SCRIPT BOT</a>
                          <p class="m-0">Download Script WABOT Lokalan, kemudian Extract script ke <strong>Hardisk D:</strong> Biar lebih gampang ya ges ya!</p>

                        </div>
                      </li>
                      <li class="mb-4">
                        <div class="listing">
                          <strong class="mb-0">4. Buka CMD pake RUN AS ADMINISTRATOR</strong>
                          <p class="m-0">Buka CMD kan biasanya defaultnya ke <strong>C: User ya</strong>, nah arahin ke hardisk D:. ketikin di bawah  </p>
                          <strong class="script-box">d:</strong>
                          <p class="m-0">Kemudian arahin ke folder <strong>WABOT LOKALAN</strong></p>
                          <strong class="script-box">cd wabot_lokalan</strong>
                          <p class="m-0">Kemudian Ketik seperti ini, tunggu sampai proses selesai</p>
                          <strong class="script-box">npm install</strong>
                          <p class="m-0">Nah Final Script, ketik </strong></p>
                          <strong class="script-box">node app.js</strong>
                          <p class="m-0">Jika muncul seperti ini, lanjut ke menu kanan <strong>WhatsApp BOT LOKALAN</strong></p>
							            <img class="icon" src="@/assets/tutorial/hasil.png" alt=""> 
                          
                          <strong class="m-0 mt-4 text-success ml-4">WEEENAAAAKKK!</strong>
                        </div>
                      </li>
                      <li>
                        <div class="listing">
                          <strong class="mb-0 text-danger">TAMBAHAN KETIKA MAU RESTART BOTNYA :</strong>
                          <p class="m-0">Jika Sudah matikan komputer atau ga sengaja ketutup botnya, langsung mulai lagi dari</p>

                          <strong class="mb-0"> Buka CMD pake RUN AS ADMINISTRATOR</strong>
                          <p class="m-0">Buka CMD kan biasanya defaultnya ke <strong>C: User ya</strong>, nah arahin ke hardisk D:. ketikin di bawah  </p>
                          <strong class="script-box">d:</strong>
                          <p class="m-0">Kemudian arahin ke folder <strong>WABOT LOKALAN</strong></p>
                          <strong class="script-box">cd wabot_lokalan</strong>
                          <p class="m-0">Nah Final Script, ketik </strong></p>
                          <strong class="script-box">node app.js</strong>

                        </div>
                      </li>
                    </ul>
                  </div>
                  <button  v-show="data.blTutorial" class="btn btn-danger " @click="data.blTutorial = false">Tutup</button>
                </div> 
              </div> 
            </div> 
            <div>
              <button class="btn btn-success btn-sm" @click="theGet.data.loadmoreState = 'all',theGet.data.page = 0, theGet.data.pageStat = 0,theGet.data.ListPelanggan = [],theGet.pelanggan(), theGet.data.checkedNames = []">Semua Pelanggan</button>
              <button class="btn btn-warning btn-sm" @click="filter.data.filterCustomBoxTagihan = true">Filter Tgl Tagihan</button>
              <button class="btn btn-primary btn-sm" @click="filter.data.areaPilih = '';filter.data.areaPilihNama = '';filter.data.modalArea = true, theGet.data.checkedNames = []">Filter Area</button>
              <button class="btn btn-success" @click="filter.data.modalPaket = true, theGet.data.checkedNames = []" v-show="false">Filter By Paket</button>
              <button class="btn btn-warning" @click="filter.data.modalAdmin = true, theGet.data.checkedNames = []" v-show="false">Filter By Admin</button>
            </div>
            <div>
              <div class="row form-group" v-show="filter.data.filterCustomBoxTagihan">
                <vuejs-datepicker :format="filter.customFormatter" class="col-md-4" placeholder="Dari Tanggal..." style="width:100%" v-model="filter.data.tglTagihan"></vuejs-datepicker>
                <button class="btn btn-secondary btn-sm" @click="filter.data.tglTagihan = '';theGet.data.loadmoreState = 'belum',theGet.data.page = 0, theGet.data.pageStat = 0,theGet.data.ListPelanggan = [],theGet.pelangganBelum(), theGet.data.checkedNames = [];filter.data.filterCustomBoxTagihan = false">Reset</button>
              </div>

              <div class="form-group" v-show="filter.data.filterAreaTagihan">
                <span class="d-block">Filter Area :</span>
                <div class="box-horizontal mb-0">
                  <span class="mr-3">{{filter.data.areaPilihNama}}</span>
                  <button class="btn btn-secondary btn-sm" @click="filter.data.areaPilih = '';filter.data.areaPilihNama = '';theGet.data.loadmoreState = 'belum',theGet.data.page = 0, theGet.data.pageStat = 0,theGet.data.ListPelanggan = [],theGet.pelangganBelum(), theGet.data.checkedNames = [];filter.data.filterAreaTagihan = false">Reset</button>
                </div>
              </div>
            </div> 

            <div>
              <button class="btn btn-info btn-sm" @click="theGet.data.loadmoreState = 'all-filter',theGet.data.page = 0, theGet.data.pageStat = 0,theGet.data.ListPelanggan = [],theGet.pelangganFilter(), theGet.data.checkedNames = []">Semua Pelanggan (filter)</button>
              <button class="btn btn-info btn-sm" @click="theGet.data.loadmoreState = 'belum',theGet.data.page = 0, theGet.data.pageStat = 0,theGet.data.ListPelanggan = [],theGet.pelangganBelum(), theGet.data.checkedNames = []">Belum Bayar</button>
              <button class="btn btn-danger btn-sm" @click="theGet.data.loadmoreState = 'belum-telat',theGet.data.page = 0, theGet.data.pageStat = 0,theGet.data.ListPelanggan = [],theGet.pelangganBelum(), theGet.data.checkedNames = []">Belum Bayar dan Telat</button>
              <button class="btn btn-danger btn-sm" @click="theGet.data.loadmoreState = 'isolir',theGet.data.page = 0, theGet.data.pageStat = 0,theGet.data.ListPelanggan = [],theGet.pelangganIsolir(), theGet.data.checkedNames = []">Isolir</button>
            </div>
            <!--
            <div class="mt-3 d-flex align-items-center" v-show="false">
              <div class="form-check mr-4">
                <input type="radio" id="flexCheckDefault" value="belum" v-model="filter.data.showAll">
                <label for="flexCheckDefault">
                  Belum Bayar Only
                </label>
              </div>
              <div class="form-check">
                <input type="radio" id="flexCheckChecked" value="all" v-model="filter.data.showAll">
                <label for="flexCheckChecked">
                  Tampilkan Semua
                </label>
              </div>
            </div>
            -->
            <div class="card" >
              <div class="card-header card-header-info">
                <div class="row">
                  <div class="col-md-12 d-flex align-items-center">
                    <h4 class="card-title flex-1">List {{theGet.data.Title}}</h4>
                  </div>
                </div>
              </div>
              <div class="card-body" >
                <div class="table-responsive">
                  <table class="table">
                    <thead class=" text-info">
                      <th width="40px">No.</th>
                      <th>Nama</th>
                      <th>Area</th>
                      <th>Tgl Tagihan</th>
                      <th>Paket</th>
                      <th>Tunggakan</th>
                      <th class="text-center"><button class="btn btn-sm btn-info" @click="theGet.pilihSemua()">Pilih Semua</button></th>
                    </thead>
                    <tbody>
                      <tr v-for="(u, index) in theGet.data.ListPelanggan">
                        <td>{{ index+1 }}</td>
                        <td>{{ u.user.unama }}</br> <span class="text-secondary">Ket : {{ u.user.wa }}</span></td>
                        <td>{{ u.area }}</td>
                        <td>{{ u.user.tanggal_tagihan }}</td>
                        <td>
                          {{ u.user.pnama }}</br>
                          {{ myGlobal.ribu(u.user.ptarif) }}
                        </td>
                        <td>{{ theGet.tunggakan(u.user.lastbayar) }} Bulan</td>
                        <td class="text-center">
                          <input type="checkbox" :value="u.user" v-model="theGet.data.checkedNames">
                        </td>
                      </tr>
                      <tr v-if="theGet.data.ListPelanggan == null">
                        <td></td>
                        <td>Tidak ada Data </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="text-center">
                  <button class="btn btn-info btn-sm" @click="theGet.loadmorePelanggan()">LoadMore...</button>
                </div>
              </div>
            </div>
            <div class="card" v-show="false">
              <div class="card-header card-header-info">
                <div class="row">
                  <div class="col-md-12">
                    <h4 class="card-title ">History WhatsApp BOT</h4>
                    <p class="card-category">Berikut ini history pelanggan yang telah di wa <strong class="text-danger">PER HARI INI</strong></p>
                  </div>
                </div>
              </div>
              <div class="card-body" >
                <div class="table-responsive">
                  <table class="table">
                    <thead class=" text-info">
                      <th width="40px">No.</th>
                      <th>Nama</th>
                      <th>Jam</th>
                      <th>Tanggal</th>
                      <th>Status</th>
                    </thead>
                    <tbody>
                      <tr v-for="(u, index) in theGet.data.List">
                        <td>{{ index+1 }}</td>
                        <td>{{ u.nama }}</br> <span class="text-secondary">Ket : {{ u.wa }}</span></td>
                        <td>{{ u.jam }}</td>
                        <td>{{ u.tanggal }}</td>
                        <td>
                            <span v-if="u.status == 'sukses'" class="text-success">Sukses</span>
                            <span v-else class="text-danger">Gagal</span>
                        </td>
                      </tr>
                      <tr v-if="theGet.data.List == null">
                        <td></td>
                        <td>Tidak ada Data </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="card">
              <div class="card-body">
                <div class="text-center">
                  <h4>Mau pakai WaBot apa?</h4>
                  <select class="form-control" id="exampleFormControlSelect1" placeholder="Pilih Wabot..."  v-model="data.pakaiWabot">
                    <option value="" selected disabled>Pilih Metode Wa Bot</option>
                    <option value="server">Server Online VPS</option>
                    <option value="chrome">Server Lokal WA Web (CUSTOM)</option>
                    <!-- <option value="cmd">Server Lokal CMD Only (Custom)</option> -->
                  </select>
                  <button class="btn btn-info" @click="wa.pilihMetode()" v-show="data.pakaiWabot != data.pakaiWabotSimpan">Pakai Metode</button>
                </div>
              </div>
            </div>
            <div class="card" v-show="data.pakaiWabotSimpan == 'server'">
              <div class="card-body">
                <div class="text-center">
                  <h4>WhatsApp BOT</h4>
                  <button v-if="data.qrreqted == '' " class="btn btn-success" @click="data.qrreqted = true, wa.qr()">Req QR</button>
                  <!-- iframe src="http://localhost:8000" title="description" style="width: 100%; height: 500px;"></iframe>  -->
                  <div class="afterklik" v-else>
                    <p class="text-info" v-if="data.barQR == ''">Tunggu yakk...</p>
                    <div v-else>
                      <img v-show="data.QRImage" :src="data.barQR" />
                      <p>{{data.QRResult}}</p>

                      <button v-show="!data.QRImage" class="btn btn-sm btn-info" @click="wa.resetWA()">Reset</button>
                      <button v-show="false" @click="wa.test()" class="btn btn-sm btn-success">Test</button>
                      <button v-show="false" @click="wa.testBlast()" class="btn btn-sm btn-success">Test Blast</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card" v-show="data.pakaiWabotSimpan == 'chrome'">
              <div class="card-body">
                <div class="text-center">
                  <h4>WABOT Lokalan Chrome</h4>
                  <label v-if="data.tipe == null" for="" class="text-info">Maaf Custom Only</label>
                  <div v-if="data.tipe != null">
                    <a class="btn btn-info" href="http://download.beatcom.web.id/?app=wabot" target="_blank">DOWNLOAD WABOT Chrome.exe</a>
                    <label for="" class="text-info">Bot akan selalu jalan di port localhost:8000, pastikan port itu tidak terpakai</label>
                    <label class="d-block text-center" for="">Cek apakah WABOT sudah jalan di PC mase?</label>
                    <button v-show="!data.blStatus" class="btn btn-success" @click="wa.cekbotlokalan()">CEK BOT</button>
                    <button v-show="data.blBuka == 'belum'" class="btn btn-info" @click="wa.bukaBotLokalan()">BUKA WA BOT LOKALAN</button>
                      
                    <!-- SIAP -->
                    <button v-show="false" class="btn btn-info" @click="wa.bukaBotKirim()">Kirim Coba</button> <!-- data.blBuka == 'siap' -->

                    <h3 v-show="data.blBuka == 'siap'" class="text-success">Wa BOT Lokalan Ready!!</h3>
                  </div>
                  
                </div>
              </div>
            </div>
            <div class="card" v-show="data.pakaiWabotSimpan == 'cmd'">
              <div class="card-body">
                <div class="text-center">
                  <h4>WABOT LOKALAN CMD Only</h4>
                  <label v-if="data.tipe == null" for="" class="text-info">Maaf Custom Only</label>
                  <div v-if="data.tipe != null">
                    <a class="btn btn-info" href="http://download.beatcom.web.id/?app=wabotnew" target="_blank">DOWNLOAD WA BOT New.exe</a>
                    <label for="" class="text-info">Bot akan selalu jalan di port localhost:8000, pastikan port itu tidak terpakai</label>
                    <label for="">Cek apakah WABOT sudah jalan di PC mase?</label>
                    <button v-show="!data.wabotNew" class="btn btn-info" @click="wa.bukaBotNew()">Buka WaBot Beatcom</button>
                    </br>
                    <button v-show="data.wabotScan == 'scan'" class="btn btn-info" @click="wa.scanBotNew()">Req QR Wa</button>
                    
                    <label for="" class="text-info"  v-show="data.wabotScan == 'tunggu'">Tunggu sebentar...</label>

                    <img v-show="data.wabotQRImage" :src="data.wabotQR" />

                    <label for="" class="text-info "  v-show="data.wabotScan == 'done'" @click="wa.scanBotNew()">Refresh Code<br></label>
                    <label for="" class="text-secondary"  v-show="data.wabotScan == 'done'">Scan menggunakan Whatsapp Anda Sekarang, Jika sudah klik tombol dibawah</label>
                    <button v-show="data.wabotScan == 'done'" class="btn btn-success" @click="wa.cekBotNew()">Saya Sudah Scan</button>

                    <!-- SIAP -->
                    <button v-show="false" class="btn btn-info" @click="wa.bukaBotKirim()">Kirim Coba</button> <!-- data.blBuka == 'siap' -->

                    <h3 v-show="data.wabotScan == 'ready'" class="text-success">Wa BOT Lokalan Ready!!</h3>

                    <h3 v-show="data.wabotScan == 'belum'" class="text-success">Wa BOT Lokalan Ready!!</h3>

                  </div>
                  
                </div>
              </div>
            </div>
            <div v-if="theGet.data.checkedNames.length > 0 && ( data.blBuka == 'siap' || !data.QRImage)">
              <button class="btn btn-primary" @click="blast.pengumuman('pengumuman')">Blast Pengumuman</button>
              <button class="btn btn-info" @click="blast.password()">Blast Password</button>
              <button class="btn btn-success" @click="blast.tagihan()">Blast Tagihan</button>
              <button class="btn btn-danger" @click="blast.pengumuman('isolir')" v-show="theGet.data.loadmoreState == 'isolir'">Blast Isolir</button>
            </div>
          </div>
          
      </div>

    </div>
    
    <!-- MODAL -->
    <div class="modal" tabindex="-1" role="dialog" v-show="blast.data.modalWAPasswordProgress"> <!-- v-show="" -->
      <div class="overlay"></div>
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Progress WA b</h5>
          </div>
          <div class="modal-body">
            <div class="text-center">
              <p class="text-info">{{blast.data.pesanKirimPause}}</p>
              <h2 class="mb-0">{{blast.data.progress}} / <small><small>{{blast.data.totalProgress}}</small></small></h2>
              <!-- <p>{{blast.data.pesanKirim}}</p> -->
              
              <p class="text-warning">Jangan tutup Popup Ini, untuk melihat progress pengiriman pesan</p>
            </div>
            <p class="fw-bold mb-2 text-info">Proses Kirim</p>
            <div class="progress-box border rounded p-3" style="max-height: 300px; overflow-y: auto;">
              <ul class="list-group list-group-flush">
                <li class="mb-1" v-for="(u, index) in dataLog.logProsesWa" v-html="u.teks"></li>
              </ul>
            </div>
          </div>
          <div class="modal-footer" v-show="blast.data.modalWAPasswordFooter">
            <button class="btn btn-success" @click="blast.data.modalWAFooter = false,blast.data.modalWAPasswordFooter = false,blast.data.modalWAPasswordProgress = false"> Tutup</button>
          </div>
        </div>
      </div>
    </div>
    
    <!-- MODAL --> 
    <div class="modal" tabindex="-1" role="dialog" v-show="blast.data.modalWAPassword">
      <div class="overlay"></div>
      <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Format WA Pesan Password Pelanggan</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="blast.data.modalWAPassword = false">
              <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body" style="overflow:auto;">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                      <div class="form-group">
                        <p class="text-info" style="margin:0" v-show="false">Format WA: </p>
                        <textarea rows="10" type="text" class="form-control" style="font-size: 10pt" placeholder="Nama Area..." v-model="blast.data.waPassDisplay" readonly></textarea>
                        <label for="" class="bmd-label-floating mt-4" v-show="false">Nama App <span class="text-danger">(Opsional, Bila anda sudah berlanggan custom app pelanggan)</span></label>
                        <small text="text-secondary" v-show="false">* Default My Wifi</small>
                        <input type="text" class="form-control" placeholder="Nama App" v-model="blast.data.appnameedit" v-show="false">
                        <label for="" class="bmd-label-floating mt-4"  v-show="false">Link App <span class="text-danger">(Opsional, Bila anda sudah berlanggan custom app pelanggan)</span></label>
                        <small text="text-secondary" v-show="false">* Default Link My Wifi</small>
                        <input type="text" class="form-control" placeholder="Link App" v-model="blast.data.applinkedit" v-show="false">
                      </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-success" @click="blast.data.modalWAPassword = false,blast.PasswordConfirm()">Kirim</button>
            </div>
        </div>
      </div>
    </div>
    
    <!-- MODAL BUAT PENGUMUMAN -->
    <div class="modal" tabindex="-1" role="dialog" v-show="blast.data.modalWA"> <!--  v-show="blast.data.modalWA" -->
      <div class="overlay"></div>
      <div class="modal-dialog" role="document" :style="data.pakaiWabotSimpan != 'server' ? { width: '980px', maxWidth: '90vw' } : {}">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Progress WA x</h5>
          </div>
          <div class="modal-body">
            <div class="row">
              <div :class="data.pakaiWabotSimpan != 'server' ? 'col-md-6' : 'col-md-12'">
                <div class="text-center">
                  <p class="text-info">{{blast.data.pesanKirimPause}}</p>
                  <h2 class="mb-0">{{blast.data.progress}} / <small><small>{{blast.data.totalProgress}}</small></small></h2>
                  <p v-if="data.blBuka != 'siap'">{{blast.data.pesanKirim}}</p>
                  
                  <p class="text-warning">Jangan tutup Popup Ini, untuk melihat progress pengiriman pesan</p>

                </div>

                <p class="fw-bold mb-2 text-info" v-show="dataLog.logProsesWa.length != 0">Proses Kirim</p>
                <div class="progress-box border rounded p-3" style="max-height: 300px; overflow-y: auto;"  v-show="dataLog.logProsesWa.length != 0">
                  <ul class="list-group list-group-flush">
                    <li class="mb-1" v-for="(u, index) in dataLog.logProsesWa" v-html="u.teks"></li>
                  </ul>
                </div>
              </div>
              <div class="col-md-6" v-if="data.pakaiWabotSimpan != 'server'">
                <div class="text-center" v-show="!dataLog.boxResume">
                  <span class="d-block text-center">Info Lain disini </span>
                </div>
                <div class="text-center" v-show="dataLog.boxResume">
                  <span class="d-block text-center">WaBot Berhenti ? </span>
                  <small class="d-block text-center">Coba Scan Ulang dan Mulai lagi dari ini</small>

                  <button class="btn btn btn-info text-center" v-show="!dataLog.btnResume" @click="dataLog.btnResume = true,data.blStatus = false,data.blBuka = null">Ulangi dan Lanjutkan kirim pesan</button>

                  <div v-show="dataLog.btnResume">
                    <div class="card" v-show="data.pakaiWabotSimpan == 'server'">
                      <div class="card-body">
                        <div class="text-center">
                          <h4>WhatsApp BOT</h4>
                          <button v-if="data.qrreqted == '' " class="btn btn-success" @click="data.qrreqted = true, wa.qr()">Req QR</button>
                          <!-- iframe src="http://localhost:8000" title="description" style="width: 100%; height: 500px;"></iframe>  -->
                          <div class="afterklik" v-else>
                            <p class="text-info" v-if="data.barQR == ''">Tunggu yakk...</p>
                            <div v-else>
                              <img v-show="data.QRImage" :src="data.barQR" />
                              <p>{{data.QRResult}}</p>

                              <button v-show="!data.QRImage" class="btn btn-sm btn-info" @click="wa.resetWA()">Reset</button>
                              <button v-show="false" @click="wa.test()" class="btn btn-sm btn-success">Test</button>
                              <button v-show="false" @click="wa.testBlast()" class="btn btn-sm btn-success">Test Blast</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="card" v-show="data.pakaiWabotSimpan == 'chrome'">
                      <div class="card-body">
                        <div class="text-center">
                          <h4>WABOT Lokalan Chrome</h4>
                          <label v-if="data.tipe == null" for="" class="text-info">Maaf Custom Only</label>
                          <div v-if="data.tipe != null">
                            <label class="d-block text-center" for="">Cek apakah WABOT sudah jalan di PC mase?</label>
                            <button v-show="!data.blStatus" class="btn btn-success" @click="wa.cekbotlokalan()">CEK BOT</button>
                            <button v-show="data.blBuka == 'belum'" class="btn btn-info" @click="wa.bukaBotLokalan()">BUKA WA BOT LOKALAN</button>
                              
                            <!-- SIAP -->
                            <button v-show="false" class="btn btn-info" @click="wa.bukaBotKirim()">Kirim Coba</button> <!-- data.blBuka == 'siap' -->

                            <h3 v-show="data.blBuka == 'siap'" class="text-success">Wa BOT Lokalan Ready!!</h3>
                          </div>
                          
                        </div>
                      </div>
                    </div>
                    <div class="card" v-show="data.pakaiWabotSimpan == 'cmd'">
                      <div class="card-body">
                        <div class="text-center">
                          <h4>WABOT LOKALAN CMD Only</h4>
                          <label v-if="data.tipe == null" for="" class="text-info">Maaf Custom Only</label>
                          <div v-if="data.tipe != null">
                            <a class="btn btn-info" href="http://download.beatcom.web.id/?app=wabotnew" target="_blank">DOWNLOAD WA BOT New.exe</a>
                            <label for="" class="text-info">Bot akan selalu jalan di port localhost:8000, pastikan port itu tidak terpakai</label>
                            <label for="">Cek apakah WABOT sudah jalan di PC mase?</label>
                            <button v-show="!data.wabotNew" class="btn btn-info" @click="wa.bukaBotNew()">Buka WaBot Beatcom</button>
                            </br>
                            <button v-show="data.wabotScan == 'scan'" class="btn btn-info" @click="wa.scanBotNew()">Req QR Wa</button>
                            
                            <label for="" class="text-info"  v-show="data.wabotScan == 'tunggu'">Tunggu sebentar...</label>

                            <img v-show="data.wabotQRImage" :src="data.wabotQR" />

                            <label for="" class="text-info "  v-show="data.wabotScan == 'done'" @click="wa.scanBotNew()">Refresh Code<br></label>
                            <label for="" class="text-secondary"  v-show="data.wabotScan == 'done'">Scan menggunakan Whatsapp Anda Sekarang, Jika sudah klik tombol dibawah</label>
                            <button v-show="data.wabotScan == 'done'" class="btn btn-success" @click="wa.cekBotNew()">Saya Sudah Scan</button>

                            <!-- SIAP -->
                            <button v-show="false" class="btn btn-info" @click="wa.bukaBotKirim()">Kirim Coba</button> <!-- data.blBuka == 'siap' -->

                            <h3 v-show="data.wabotScan == 'ready'" class="text-success">Wa BOT Lokalan Ready!!</h3>

                            <h3 v-show="data.wabotScan == 'belum'" class="text-success">Wa BOT Lokalan Ready!!</h3>

                          </div>
                          
                        </div>
                      </div>
                    </div>

                    <div v-show="data.blBuka == 'siap'">
                      <button class="btn btn-info" @click="dataLog.boxResume = false,blast.lanjutkan()">Lanjutkan</button>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer" v-show="blast.data.modalWAFooter">
            <button class="btn btn-success" @click="blast.data.modalWAPasswordFooter = false,blast.data.modalWAFooter = false,blast.data.modalWA = false,dataLog.boxResume = false">Tutup</button>
          </div>
        </div>
      </div>
    </div>  
    
    <!-- MODAL -->
    <div class="modal" tabindex="-1" role="dialog" v-show="blast.data.modalWABlast">
      <div class="overlay"></div>
      <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Blast Wa</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="blast.data.modalWABlast = false">
              <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                      <div class="form-group">
                        <label class="bmd-label-floating">Ketikan Teks yang akan di kirim</label>
                        <textarea rows="10" type="text" class="form-control" placeholder="Nama Area..." v-model="blast.data.pengumumanTeks"></textarea>
                      </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-success" @click="blast.data.modalWABlast = false,blast.testTextToURL()">Kirim</button>
            </div>
        </div>
      </div>
    </div>

    <!-- MODAL -->
    <div class="modal" tabindex="-1" role="dialog" v-show="filter.data.modalArea">
      <div class="overlay"></div>
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Pilih Area</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="filter.data.modalArea = false, filter.data.areaPilih = '', filter.data.areaPilihNama = ''">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12" style="height: 400px; overflow: auto">
                <div class="table-responsive">
                  <table class="table">
                    <thead class=" text-info">
                      <th>No.</th>
                      <th>Nama</th>
                      <th>Aksi</th>
                    </thead>
                    <tbody>
                      <tr v-for="(u, index) in filter.data.area">
                        <td>{{ index+1 }}</td>
                        <td>{{ u.nama }}</td>
                        <!-- td>{{ u.jumlah }}</td> -->
                        <td>
                          <button class="btn btn-sm btn-primary" @click="theGet.pilihArea(u.id,u.nama);"> Pilih</button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="col-md-6">
              <label>Area By :</label>
              <span>{{ filter.data.areaPilihNama }}</span>
            </div>
            <div class="col-md-6 text-right">
              <button class="btn btn-primary" @click="theGet.data.loadmoreState = 'belum', theGet.data.page = 0, theGet.data.pageStat = 0, filter.data.modalArea = false;filter.data.filterAreaTagihan = true;theGet.data.ListPelanggan = [];theGet.pelangganBelum() "> Filter Now</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL -->
    <div class="modal" tabindex="-1" role="dialog" v-show="filter.data.modalPaket">
      <div class="overlay"></div>
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Pilih Paket</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="filter.data.modalPaket = false">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12" style="height: 400px; overflow: auto">
                <div class="table-responsive">
                  <table class="table">
                    <thead class=" text-info">
                      <th>No.</th>
                      <th>Nama</th>
                      <th>Aksi</th>
                    </thead>
                    <tbody>
                      <tr v-for="(u, index) in filter.data.paket">
                        <td>{{ index+1 }}</td>
                        <td>{{ u.nama }}</td>
                        <!-- td>{{ u.jumlah }}</td> -->
                        <td>
                          <button class="btn btn-sm btn-primary" @click="filter.cariByPaket(u.id,u.nama);"> Pilih</button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- MODAL -->
    <div class="modal" tabindex="-1" role="dialog" v-show="filter.data.modalAdmin">
      <div class="overlay"></div>
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Pilih Paket</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="filter.data.modalAdmin = false">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12" style="height: 400px; overflow: auto">
                <div class="table-responsive">
                  <table class="table">
                    <thead class=" text-info">
                      <th>No.</th>
                      <th>Nama</th>
                      <th>Aksi</th>
                    </thead>
                    <tbody>
                      <tr v-for="(u, index) in filter.data.admin">
                        <td>{{ index+1 }}</td>
                        <td>{{ u.nama }}</td>
                        <!-- td>{{ u.jumlah }}</td> -->
                        <td>
                          <button class="btn btn-sm btn-primary" @click="filter.cariByAdmin(u.area,u.nama);"> Pilih</button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="footer-check pl-3 pr-3 pt-2 pb-2" v-show="theGet.data.checkedNames.length > 0 || dataLog.checkedNamesResume.length > 0">
        <div class="row">
          <div class="col-md-2">
            <small>Wa Bot</small>
            <p class="mb-0 text-info" >Pelanggan Terpilih</p>
          </div>
          <div class="col-md-2 text-center">
            <p class="mb-0">{{theGet.data.checkedNames.length || dataLog.checkedNamesResume.length}}</p>
            <small>Pelanggan</small>
          </div>
          <div class="col-md-8" v-show="dataLog.boxResume">
            <div class="row">
              <div class="col-sm-6">
                <span class="d-block text-center">WaBot Berhenti ? </span>
                <small class="d-block text-center">Coba Scan Ulang dan Mulai lagi dari ini</small>
              </div>
              <div class="text-right col-sm-6 d-flex align-items-center justify-content-center">
                <button class="btn btn btn-info d-block text-center" @click="blast.data.modalWAPasswordProgress = false,blast.data.modalWA = false">Tutup Popup</button>
                <button class="btn btn btn-info d-block text-center" v-show="dataLog.btnResume">Lanjutkan kirim pesan</button>
              </div>
            </div>
          </div>
        </div>
    </div> -->
  </div>
</template>

<script>
import Vue from 'vue'
import { reactive } from '@vue/composition-api'
import myGlobal from '@/globalFunc/myGlobal' 
import inter from '@/globalFunc/Interface' 
import interBotLokal from '@/globalFunc/InterfaceBotLokalan' 
import vuejsDatepicker from 'vuejs-datepicker' 
import { loginFor,linkWebPelanggan } from '@/var/var.js'
import moment from 'moment'

export default {
  name: 'Beranda',
  components: { 
    vuejsDatepicker
  }, 
  sockets: {
    /*
    message: function(val){
      console.log(val)
    },
    */
    error: function(text){
      alert(text)
    },
    qr: function(url) {
      //console.log(url)

      this.data.barQR = url;
    },
    ready(val) {

      if (val == "terverifikasi") {

        this.data.QRResult = 'Whatsapp is ready!';
        this.data.QRImage = false;

        //this.wa.saveSesi();

        this.$socket.emit('monitor-chat');
        
        sessionStorage.setItem('walogin', "new");
      }

      console.log(val);
      //this.data.sesi = sesi;


      //alert("Whatsapp redi");

    },
    sent: function(val) {
      //console.log(val)
      
      if(val == "sukses") {
        this.blast.data.pesanKirimPause = "Pesan berhasil Dikirim";
        this.blast.data.modalWAFooter = true;
        this.blast.data.modalWAPasswordFooter = true;
        this.theGet.data.checkedNames = [];
        //this.blast.data.selectWaBlast = false;
      } else if (val == "start") {
        this.blast.data.pesanKirimPause = "Mulai Mengirim Pesan..";
      } else if (val == "restart") {
        this.blast.data.pesanKirimPause = "Lanjoet Mengirim Pesan...";
      } else if (val == "pause") {
        this.blast.data.pesanKirimPause = "Di Pause 15s, biar ga ke blokir akak No WhatsAppnya";
      } else {
        this.blast.data.pesanKirim = val;
        this.blast.data.progress = this.blast.data.progress + 1;
      }
    }
  },
  setup() {
    const data = reactive({
      QRResult: 'Scan QRnya om. Tahan Scanner WAnya sampai sukses ya. Huehehe',
      QRImage: true,
      socket: '',
      barQR: '',
      filtered: '',
      qrreqted: '',
      sesi: '',

      tipe: null, // apakah custom

      // bot lokal
      blStatus: false,
      blBuka: null, // belum / terbuka / siap /
      blTutorial: false,

      wabotNew: false,
      wabotScan: "scan", //null,"scan"
      wabotQRImage: null,
      wabotQR: null,

      pakaiWabot: "",
      pakaiWabotSimpan: null,

      /* modal edit tarif */
    })

    const dataLog = reactive({
      logProsesWa: [],
      boxResume: false,
      checkedNamesResume: [],
      btnResume: false,
      sedangKirimApa: null,
      sampaiBerapa: 0,
      pengumumanTeks: null,
      passwordTeks: null,
    })


    const wa = {
      pilihMetode() {
        if(data.pakaiWabot == "") {
          return false;
        }

        if(data.pakaiWabot == "server") {
		      sessionStorage.setItem('walokallogin', "kosong");
          data.blBuka = null;
        }

        data.pakaiWabotSimpan = data.pakaiWabot

        sessionStorage.setItem("wabot", data.pakaiWabot);

        //console.log(data.pakaiWabotSimpan);
      },
      /* WABOT NEW VERSION */
      async cekBotOnline() {
        console.log("is online");

        var datax = {
            token: 'TangTung ' + sessionStorage.getItem('myToken')
        };

        var apiUrl = interBotLokal.isonline();

        try {
            // Gunakan await untuk menghentikan eksekusi sampai response diterima
            const x = await myGlobal.callBot(datax, apiUrl);
            
            console.log(JSON.stringify(x));

            if (x.status == true) {
                data.wabotNew = true;
                data.wabotScan = "scan";
                
                // Jika kamu ingin berhenti di sini jika status true, gunakan return
                return false; 
            } else {
                // alert(x.pesan);
            }
        } catch (error) {
            console.error("Gagal memanggil bot:", error);
        }

        // Kode di bawah ini SEKARANG akan menunggu sampai callBot selesai
        
        // Membuka tab baru yang menjalankan proses launch
        const newTab = window.open("beatcom-wabot://launch", "_blank");

        // Memberikan jeda sebentar agar browser sempat memproses protocol launch,
        // kemudian menutup tab tersebut secara otomatis.
        if (newTab) {
            setTimeout(() => {
                newTab.close();
            }, 500); 
        }

        data.wabotNew = true;
        data.wabotScan = "scan";
      },
      bukaBotNew() {
        wa.cekBotOnline();
      },
      scanBotNew() {

        //console.log("scan now");
        
        data.wabotScan = "tunggu";

        var datax = {
          token: 'TangTung '+sessionStorage.getItem('myToken')
        };
    
        var apiUrl = interBotLokal.scan();
        myGlobal.callBot(datax,apiUrl).then(x => {
            //console.log("coba");
            //console.log(JSON.stringify(x));

            if (x.status == true) {
              //data.blStatus = x.status
              //data.blBuka = "belum"

              if (x.info == "ready") {
                data.wabotQRImage = false;
                data.wabotScan = "ready";
                
                data.wabotNew = true;
                
                data.blBuka = "siap"; 
                sessionStorage.setItem("walokallogin", "siap");

                return false;
              }

              data.wabotQRImage = true;
              data.wabotScan = "done";
              data.wabotQR = x.info;

              /*
              if(x.info == "siap") {
                console.log("wokeh siap")
                data.blBuka = "siap"; 
                sessionStorage.setItem("walokallogin", "siap");
              }
                */
            } else {
              //alert(x.pesan);
            }
        })
      },
      cekBotNew() {
        var datax = {
          token: 'TangTung '+sessionStorage.getItem('myToken')
        };
    
        var apiUrl = interBotLokal.cek();
        myGlobal.callBot(datax,apiUrl).then(x => {
            console.log("coba");
            //console.log(JSON.stringify(x));
            if (x.status == true) {
              if (x.info == "ready") {
                data.wabotQRImage = false;
                data.wabotScan = "ready";
                
                data.blBuka = "siap"; 
                sessionStorage.setItem("walokallogin", "siap");
              } else {
                data.wabotQRImage = false;
                data.wabotScan = "belum";
              }
              
              
            } else {
              //alert(x.pesan);
            }
        })

      },


      /* WABOT NEW VERSION END */


      cekbotlokalan() {
        var datax = {
          token: 'TangTung '+sessionStorage.getItem('myToken'),
          kelas: "x10l6tqk"
        };
    
        var apiUrl = interBotLokal.cekLokal();
        myGlobal.callBot(datax,apiUrl).then(x => {
            console.log("coba");
            console.log(JSON.stringify(x));
            if (x.status == true) {
              data.blStatus = x.status
              data.blBuka = "belum"
              if(x.info == "siap") {
                console.log("wokeh siap")
                data.blBuka = "siap"; 
                sessionStorage.setItem("walokallogin", "siap");
              }
            } else {
              //alert(x.pesan);
            }
        })
      },
      bukaBotLokalan() {
        var datax = {
          token: 'TangTung '+sessionStorage.getItem('myToken')
        };
    
        var apiUrl = interBotLokal.buka();
        myGlobal.callBot(datax,apiUrl).then(x => {
            console.log(JSON.stringify(x));
            if (x.status == true) {
              data.blBuka = "siap"; 
              sessionStorage.setItem("walokallogin", "siap");
            } else {
              //alert(x.pesan);
            }
        })
      },
      bukaBotKirim(hp, teks) {

        if(hp.length < 7) { 
          console.log("No hp terlalu pendek");
          return false;
        }

        if(hp.length > 15) { 
          console.log("No hp terlalu Panjang");
          return false;
        }

        var datax = {
          hp: hp,
          text: teks
        };
    
        var apiUrl = interBotLokal.kirim();
        myGlobal.callBot(datax,apiUrl).then(x => {
            console.log(JSON.stringify(x));
            if (x.status == true) {

            } else {
              //alert(x.pesan);
            }
        })
      },
      qr() {
        //console.log("admin id "+sessionStorage.getItem('id'))
        

        var datax = {
          id: sessionStorage.getItem('id'),
          stat: "new"
        }
        data.socket.emit('login', datax);
      },
      saveSesi() {
        var datax = {
            token: 'TangTung '+sessionStorage.getItem('myToken'),
            sesi: "hilih kintil"
        };
    
        var apiUrl = inter.SaveSesi();
        myGlobal.call(datax,apiUrl).then(x => {
            //console.log(JSON.stringify(x));
            if (x.status == true) {
              //this.data.List = x.data;
            } else {
              //alert(x.pesan);
            }
        })
      },
      getSesi() {
        if (sessionStorage.getItem('walogin') == 'kosong') {
            data.qrreqted = "";
            data.barQR = "";
            data.QRResult = 'Scan QRnya om. Huehehe';
            data.QRImage = true;
            data.sesi = "";
        } else {
            data.qrreqted = true;
            data.barQR = true;
            data.QRResult = 'Whatsapp is ready!';
            data.QRImage = false;
            data.sesi = "login";
        }

        /*
        var datax = {
          token: 'TangTung '+sessionStorage.getItem('myToken')
        };
    
        var apiUrl = inter.GetSesi();
        myGlobal.call(datax,apiUrl).then(x => {
          console.log(JSON.stringify(x));
          //console.log(JSON.parse(x.data));
          if (x.status == true) {
            //this.data.List = x.data;
            
            data.qrreqted = true;
            data.barQR = true;
            data.QRResult = 'Whatsapp is ready!';
            data.QRImage = false;
            data.sesi = x.data;

          } else {
            //alert(x.pesan);
          }
        })
        */
      },
      test() {
        //data.socket.emit('kirim', data.sesi);
      },
      testBlast() {
        //data.socket.emit('kirim-blast', data.sesi);
      },
      resetWA() {
        data.socket.emit('destroy', "okelah bro");
        sessionStorage.setItem('walogin', "kosong");

        data.qrreqted = "";
        data.barQR = "";
        data.QRResult = 'Scan QRnya om. Huehehe';
        data.QRImage = true;
        data.sesi = "";

        /*
        var datax = {
          token: 'TangTung '+sessionStorage.getItem('myToken')
        };
    
        var apiUrl = inter.ResetWA();
        myGlobal.call(datax,apiUrl).then(x => {
          //console.log(JSON.stringify(x));
          //console.log(JSON.stringify(x.data));
          if (x.status == true) {
            //this.data.List = x.data;

            data.qrreqted = "";
            data.barQR = "";
            data.QRResult = 'Scan QRnya om. Huehehe';
            data.QRImage = true;
            data.sesi = "";

          } else {
            //alert(x.pesan);
          }
        })
          */
      }
    }

    const blast = {
      data: reactive({
        modalWABlast: false,
        modalWAPassword: false,
        pengumumanTeks: null,
        progress: 0,
        modalWA: false,
        totalProgress: 0,
        pesanKirimPause: "",
        modalWAFooter: false,
        modalWAPasswordFooter: false,
        modalWAPasswordProgress: false,
        pesanKirim: "",

        modalWAPassword: false,
        appname: "My Wifi",
        applink: linkWebPelanggan, //'https://mywifi.beatcom.web.id',
        waPass : 'Halo Pak/Bu [[nama]], Yuk Login ke Aplikasi buat Pelanggan *[[rtrw]]* buat liat pembayarannya \n\nTelepon : [[telepon]] \nPassword : [[password]] \n\nLogin " [[appnamex]] " via Web ya. \nLink : [[applinkx]] \n\nTerima Kasih',
        waPassDisplay : 'Halo Pak/Bu [[nama]], Yuk Login ke Aplikasi buat Pelanggan *[[rtrw]]* buat liat pembayarannya \n\nTelepon : [[telepon]] \nPassword : [[password]] \n\nLogin " [[appnamex]] "  via Web ya. \nLink : [[applinkx]] \n\nTerima Kasih',
        appnameedit: '',
        applinkedit: '',
        namaQ: ''
      }),
      tagihan() {
        let pakaiWA = "server";

        dataLog.logProsesWa = [];

        console.log(sessionStorage.getItem("walokallogin"));
        // CEK WA LOKALAN
        if(sessionStorage.getItem("walokallogin") == "kosong") {
          // CEK WA SERVER
          if (sessionStorage.getItem('walogin') == 'kosong') {
            alert('Anda belum scan wa');
            return false;
          }
          if (sessionStorage.getItem('walogin') == 'belum') {
            alert('Anda belum scan wa');
            return false;
          }
        } else {
          if(sessionStorage.getItem("walokallogin") != "siap") {
            alert('Wa Bot lokal belum siap');
            return false;
          } else {
            // sudah siap
            pakaiWA = "lokal";
          }
        }

        // WA LOKAL SIAP
        if(data.blBuka == "siap") {
          pakaiWA = "lokal";
        }

        console.log("pakai apa "+pakaiWA);

        this.data.progress = 0;

        this.data.modalWA = true;

        this.data.totalProgress = theGet.data.checkedNames.length;
        
        var d = new Date();
        var n = d.getMonth();
        var bulan = n + 1;
        if (sessionStorage.getItem('bulanIdBase') != "0") {
          bulan = sessionStorage.getItem('bulanIdBase');
        }
        var bulanNowRealsekali = sessionStorage.getItem('tahunBase')+"-"+bulan+"-01";
        //console.log("bulan : " + bulan + " - " +sessionStorage.getItem('bulanIdBase'));
        
        var theData = { // datax (index wa bot)
          data: JSON.stringify({ // datae (index wa bot)
            data: theGet.data.checkedNames, // dataOnly (index wa bot)
            pesan: "Bebas sih ini",
            status: true
          }),
          token: null, //this.sesi,
          bulan: myGlobal.getBulanNow()+ ' ' + myGlobal.getTahunNow(),
          bulanNow: bulanNowRealsekali, // tujuannya biar tanggal 30 sudah bisa blast untuk bulan depan, misal harusnya kirim blast tgl 1 jan, bisa di kiirm 30 des
          namaKu: sessionStorage.getItem('admin'),
          wateks: sessionStorage.getItem('wateks'),
          ppn: sessionStorage.getItem('PPN'),
          bayaronline: sessionStorage.getItem('bayarOnline')
        }
        // console.log(JSON.stringify(theData));

        if(pakaiWA == "server") {

          data.socket.emit('kirim-blast', theData);

        } else {
          blast.lokalTagihan(theData);
        }
      },  
      lokalTagihan(Data,mulaidari) {
        dataLog.sedangKirimApa = "tagihan";
        
        console.log("bangga pakai lokal Tagihan");

        dataLog.logProsesWa = [];

        let datax = Data;

        // KIRIM STATUS
        blast.statusBlast("start");
        
        var datae = JSON.parse(datax.data);
        var dataOnly = datae.data;
        //console.log(dataOnly.length);
        var kirimJumlah = dataOnly.length;

        var statKirim = 0;
        if(mulaidari != null) {
          statKirim = mulaidari;
        }

        const ribu = function(x) {
            var harga = 0;
            if (x != "") {
                try {
                    harga = x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                }
                catch(err) {
                    //
                }
            }

            return 'Rp. '+harga;
        }
        const paInt = function(x) {
            var harga = 0;
            if (x != "") {
                try {
                    harga = x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

                    harga = parseInt(x);
                }
                catch(err) {
                    //
                }
            }

            return harga;
        }
        
        const kirimPesan = function() {
            var userD = dataOnly[statKirim];
            
            var b1= "",b2= "",b1J= 0,b2J= 0,diskonT = "";
            if (userD.biaya_rincian != null) {
                b1 = "\nBiaya "+userD.biaya_rincian+" : "+ribu(userD.biaya_tambahan);
                b1J = userD.biaya_tambahan;
            }
            if (userD.biaya_tambahan_2 != null) {
                b2 = "\nBiaya "+userD.biaya_rincian_2+" : "+ribu(userD.biaya_tambahan_2);
                b2J = userD.biaya_tambahan_2;
            }
            
            if (userD.diskon != "0") {
                diskonT = "\nDiskon : "+ribu(userD.diskon);
            }
            
            var TotalIuran = ( paInt(b1J) + paInt(b2J) + parseInt(userD.tarif) + parseInt(( datax.ppn / 100 ) * userD.tarif) ) - paInt(userD.diskon);

            var bayarOnlineText = "\nBayar via Online : "+blast.data.applink+"/#/inv/"+userD.uid+"\n";
            if (datax.bayaronline == "tidak") {
                bayarOnlineText = "";
            }

            var bulanNowRealsekali = datax.bulanNow;
            const tunggakan = function(x) {
                var months;
                var lastbayar = new Date(x);
                var today = new Date(bulanNowRealsekali);
                months = (today.getFullYear() - lastbayar.getFullYear()) * 12;
                months -= lastbayar.getMonth();
                months += today.getMonth();
                return months <= 0 ? 0 : months;
            }
            
            var bulanNama = ['Jan', 'Feb', 'Mar', 'Apr', 'Mei', 'Jun', 'Jul', 'Ags', 'Sept', 'Okt', 'Nov', 'Des'];
            var lastbayar = userD.lastbayar;
            var jumlahnunggak = parseInt( tunggakan(lastbayar) );
            var realBulan = "";
            if (jumlahnunggak < 0) {
                var newDate = new Date();
                realBulan = bulanNama[parseInt(newDate.getMonth())]+' '+newDate.getFullYear();
            } else {
                for (let i = 0; i < jumlahnunggak; i++) {
                    var dateSekarang = new Date(bulanNowRealsekali);
                    var newDate = new Date(dateSekarang.setMonth(dateSekarang.getMonth() - i ));
                    if (realBulan == "") {
                      realBulan = bulanNama[parseInt(newDate.getMonth())]+' '+newDate.getFullYear();
                    } else {
                        realBulan = bulanNama[parseInt(newDate.getMonth())]+' '+newDate.getFullYear() + ", " + realBulan ;
                        
                    }
                } 
                
                TotalIuran = parseInt(TotalIuran) * parseInt(jumlahnunggak);
            }

            let ppnval = datax.ppn;
            let ppnTeks = "";
            if(ppnval != "0") {
              ppnTeks = "\nPPN "+ datax.ppn +"% : "+ribu( ( datax.ppn / 100 ) * userD.tarif);
            }

            var pesan = "*"+datax.namaKu+"* \n\n*PELANGGAN*\nYth. Bpk/Ibu "+userD.unama+
                    "\n"+userD.wa+
                    "\n\n*PEMBERITAHUAN*\nTagihan Bulan : "+realBulan+"\n" + //+bulan[sTglTagihan]
                    "Jenis Paket : "+userD.pnama+
                    "\nBiaya Paket : "+ribu(userD.tarif)+
                    b1 +
                    b2 + 
                    ppnTeks +
                    //"\nPPN "+ datax.ppn +"% : "+ribu( ( datax.ppn / 100 ) * userD.tarif) +
                    diskonT +
                    "\nBesar Tagihan + PPN : "+ribu(TotalIuran)+ 
                    "\n\nMasa aktif s/d " + userD.tanggal_tagihan + " " + datax.bulan +"\n" +
                    "\nKet : *BELUM TERBAYAR*"+bayarOnlineText+
                    "\nINFO TAMBAHAN\n" +datax.wateks; // \nNote : Abaikan WA ini jika sudah melakukan Pembayaran 
                    
            var noWa = userD.wa;
            noWa = noWa.replace(/\s/g, "");
            
            var first = noWa.charAt(0);
            if (first == "0") {
                noWa = "62"+noWa.substring(1);
            }
            
            /*
            if (client.client == "") {
                return false;
            }
            */
            
            setTimeout(function(){ 

                // KIRIM DISINI
                /*
                client.client.sendMessage(noWa+"@c.us", pesan).then(response => {
                    
                    //console.log(response);
    
                    console.log('\x1b[36m%s\x1b[0m', 'Mengirim Pesan Oleh '+ myid + " terkirim ke "+ dataOnly[statKirim].unama);
                    
                }).catch(err => {
                    // INI GA USAH ANJAY // ABAIKAN AJALAH BABY
                });
                */

                //wa.bukaBotKirim(noWa, pesan); 

                /*
                
                if(hp.length < 7) { 
                  console.log("No hp terlalu pendek");
                  return false;
                }

                if(hp.length > 15) { 
                  console.log("No hp terlalu Panjang");
                  return false;
                }

                */

                var datax = {
                  hp: noWa,
                  text: pesan
                };
            
                var apiUrl = interBotLokal.kirim();
                myGlobal.callBot(datax,apiUrl).then(x => {
                    console.log("hasil wa bot tagihan");

                    //console.log(JSON.stringify(x));

                    if (x.status == true) {
                      
                      // socket.emit('sent', "Berhasil mengirim ke "+dataOnly[statKirim].unama+ ' - '+dataOnly[statKirim].wa);
                      // blast.statusBlast("Berhasil mengirim ke "+dataOnly[statKirim].unama+ ' - '+dataOnly[statKirim].wa);

                      if(x.info == "gagal-kirim") {
                        blast.statusBlast("<strong class='text-danger'>Gagal</strong> mengirim ke "+dataOnly[statKirim].unama+ ' - '+dataOnly[statKirim].wa);
                      } else {
                        blast.statusBlast("Berhasil mengirim ke "+dataOnly[statKirim].unama+ ' - '+dataOnly[statKirim].wa);
                      }
                                      
                      statKirim = statKirim + 1;

                      dataLog.sampaiBerapa = statKirim;

                      stat15sKirim = stat15sKirim + 1;
                      if (statKirim < kirimJumlah) {
                          if (stat15sKirim < stat15Jumlah) {
                              setTimeout(function(){ 
                                  kirimPesan(); 
                              }, 10000);
                          } else {
                              breakUp15s();
                          }
                      } else {
                        //socket.emit('sent', 'sukses');
                              
                        blast.statusBlast("sukses");

                          // DESTROY SETELAH BLAST KELAR
                      }

                    } else {
                      //alert(x.pesan);
                    }
                })
                .catch(error => {
                  //var error = error.response.status;
                  //this.error(error);

                  
                  dataLog.boxResume = true;


                });;

            }, 5000);
        }

        var stat15Jumlah = 4;
        var stat15sKirim = 0;

        const breakUp15s = function() {
          
            //.emit('sent', "pause");
            blast.statusBlast("pause");

            stat15sKirim = 0;
            setTimeout(function(){ 
                kirimPesan(); 
                //socket.emit('sent', "restart");
                blast.statusBlast("restart");
            }, delayRandom);
        }

        console.log("gas kirim ");
        kirimPesan();
      },
      lanjutkan() {
        let kirim = dataLog.sedangKirimApa;

        if(kirim == "pengumuman") {
          var theData = {
            data: JSON.stringify({
              data: theGet.data.checkedNames
            }), 
            pesanwa: dataLog.pengumumanTeks
          }
          blast.lokalTagihanNoTemplate(theData,dataLog.sampaiBerapa);
        } else if(kirim == "password") {
          var theData = {
            data: JSON.stringify({
              data: theGet.data.checkedNames
            }), 
            pesanwa: dataLog.passwordTeks
          }
          blast.lokalTagihanPassword(theData,dataLog.sampaiBerapa);
        } else if(kirim == "tagihan") {
          var d = new Date();
          var n = d.getMonth();
          var bulan = n + 1;
          if (sessionStorage.getItem('bulanIdBase') != "0") {
            bulan = sessionStorage.getItem('bulanIdBase');
          }
          var bulanNowRealsekali = sessionStorage.getItem('tahunBase')+"-"+bulan+"-01";
          var theData = { // datax (index wa bot)
            data: JSON.stringify({ // datae (index wa bot)
              data: theGet.data.checkedNames, // dataOnly (index wa bot)
              pesan: "Bebas sih ini",
              status: true
            }),
            token: null, //this.sesi,
            bulan: myGlobal.getBulanNow()+ ' ' + myGlobal.getTahunNow(),
            bulanNow: bulanNowRealsekali, // tujuannya biar tanggal 30 sudah bisa blast untuk bulan depan, misal harusnya kirim blast tgl 1 jan, bisa di kiirm 30 des
            namaKu: sessionStorage.getItem('admin'),
            wateks: sessionStorage.getItem('wateks'),
            ppn: sessionStorage.getItem('PPN'),
            bayaronline: sessionStorage.getItem('bayarOnline')
          }
          
          blast.lokalTagihan(theData,dataLog.sampaiBerapa);

        }
      },
      lokalTagihanNoTemplate(Data,mulaidari) {
        dataLog.sedangKirimApa = "pengumuman";
        console.log("bangga pakai lokal pengumuman");

        dataLog.logProsesWa = [];

        let datax = Data;

        // KIRIM STATUS
        blast.statusBlast("start");
        
        var datae = JSON.parse(datax.data);
        var dataOnly = datae.data;
        //console.log(dataOnly.length);
        var kirimJumlah = dataOnly.length;

        var statKirim = 0;
        if(mulaidari != null) {
          statKirim = mulaidari;
        }
        
        const kirimPesan = function() {

            console.log("lagi disini");

            var userD = dataOnly[statKirim];
            
            var pesan = datax.pesanwa;

            var noWa = userD.wa;
            noWa = noWa.replace(/\s/g, "");
            
            var first = noWa.charAt(0);
            if (first == "0") {
                noWa = "62"+noWa.substring(1);
            }
            
            /*
            if (client.client == "") {
                return false;
            }
            */
            
            setTimeout(function(){ 

                // KIRIM DISINI
                /*
                client.client.sendMessage(noWa+"@c.us", pesan).then(response => {
                    
                    //console.log(response);
    
                    console.log('\x1b[36m%s\x1b[0m', 'Mengirim Pesan Oleh '+ myid + " terkirim ke "+ dataOnly[statKirim].unama);
                    
                }).catch(err => {
                    // INI GA USAH ANJAY // ABAIKAN AJALAH BABY
                });
                */
                // wa.bukaBotKirim(noWa, pesan);

                
                /*
                if(noWa.length < 7) { 
                  console.log("No hp terlalu pendek");
                  return false;
                }

                if(noWa.length > 15) { 
                  console.log("No hp terlalu Panjang");
                  return false;
                }
                  */

                var datax = {
                  hp: noWa,
                  text: pesan
                };
            
                var apiUrl = interBotLokal.kirim();
                myGlobal.callBot(datax,apiUrl).then(x => {
                    console.log("hasil wa bot pengumuman");
                    //console.log(JSON.stringify(x));
                    if (x.status == true) {
                      
                      // socket.emit('sent', "Berhasil mengirim ke "+dataOnly[statKirim].unama+ ' - '+dataOnly[statKirim].wa);

                      if(x.info == "gagal-kirim") {
                        blast.statusBlast("<strong class='text-danger'>Gagal</strong> mengirim ke "+dataOnly[statKirim].unama+ ' - '+dataOnly[statKirim].wa);
                      } else {
                        blast.statusBlast("Berhasil mengirim ke "+dataOnly[statKirim].unama+ ' - '+dataOnly[statKirim].wa);
                      }
                                      
                      statKirim = statKirim + 1;

                      dataLog.sampaiBerapa = statKirim;

                      stat15sKirim = stat15sKirim + 1;
                      if (statKirim < kirimJumlah) {
                          if (stat15sKirim < stat15Jumlah) {
                              setTimeout(function(){ 
                                kirimPesan(); 
                              }, 10000);
                          } else {
                              breakUp15s();
                          }
                      } else {
                        //socket.emit('sent', 'sukses');
                              
                        blast.statusBlast("sukses");

                          // DESTROY SETELAH BLAST KELAR
                      }


                    } else {
                      //alert(x.pesan);
                      // console.log("gagal")

                    }
                })
                .catch(error => {
                  //var error = error.response.status;
                  //this.error(error);

                  
                  dataLog.boxResume = true;


                });;


            }, 5000);
        }

        var stat15Jumlah = 4;
        var stat15sKirim = 0;

        const breakUp15s = function() {
            //.emit('sent', "pause");
            blast.statusBlast("pause");

            stat15sKirim = 0;
            setTimeout(function(){ 
                kirimPesan(); 
                //socket.emit('sent', "restart");
                blast.statusBlast("restart");
            }, 15000);
        }

        console.log("gas kirim ");
        kirimPesan();
      },
      lokalTagihanPassword(Data,mulaidari) {
        dataLog.sedangKirimApa = "password";
        console.log("bangga pakai lokal Password");

        dataLog.logProsesWa = [];

        let datax = Data;

        // KIRIM STATUS
        blast.statusBlast("start");
        
        var datae = JSON.parse(datax.data);
        var dataOnly = datae.data;
        //console.log(dataOnly.length);
        var kirimJumlah = dataOnly.length;
        var statKirim = 0;
        if(mulaidari != null) {
          statKirim = mulaidari;
        }
        
        const kirimPesan = function() {
            var userD = dataOnly[statKirim];
            
            var pesan = datax.pesanwa;

            var noWa = userD.wa;
            noWa = noWa.replace(/\s/g, "");
            
            pesan = pesan.replace("[[telepon]]", userD.wa);
            pesan = pesan.replace("[[nama]]", userD.unama);
            
            var first = noWa.charAt(0);
            if (first == "0") {
                noWa = "62"+noWa.substring(1);
            }
            
            /*
            if (client.client == "") {
                return false;
            }
            */
            
            setTimeout(function(){ 

                // KIRIM DISINI
                /*
                client.client.sendMessage(noWa+"@c.us", pesan).then(response => {
                    
                    //console.log(response);
    
                    console.log('\x1b[36m%s\x1b[0m', 'Mengirim Pesan Oleh '+ myid + " terkirim ke "+ dataOnly[statKirim].unama);
                    
                }).catch(err => {
                    // INI GA USAH ANJAY // ABAIKAN AJALAH BABY
                });
                */
                //wa.bukaBotKirim(noWa, pesan);
                
                var datax = {
                  hp: noWa,
                  text: pesan
                };
            
                var apiUrl = interBotLokal.kirim();
                myGlobal.callBot(datax,apiUrl).then(x => {
                    console.log("hasil wa bot password");
                    //console.log(JSON.stringify(x));

                    if (x.status == true) {
                      
                      // socket.emit('sent', "Berhasil mengirim ke "+dataOnly[statKirim].unama+ ' - '+dataOnly[statKirim].wa);
                      //blast.statusBlast("Berhasil mengirim ke "+dataOnly[statKirim].unama+ ' - '+dataOnly[statKirim].wa);

                      if(x.info == "gagal-kirim") {
                        blast.statusBlast("<strong class='text-danger'>Gagal</strong> mengirim ke "+dataOnly[statKirim].unama+ ' - '+dataOnly[statKirim].wa);
                      } else {
                        blast.statusBlast("Berhasil mengirim ke "+dataOnly[statKirim].unama+ ' - '+dataOnly[statKirim].wa);
                      }
                                      
                      statKirim = statKirim + 1;

                      dataLog.sampaiBerapa = statKirim;

                      stat15sKirim = stat15sKirim + 1;
                      if (statKirim < kirimJumlah) {
                          if (stat15sKirim < stat15Jumlah) {
                              setTimeout(function(){ 
                                  kirimPesan(); 
                              }, 10000);
                          } else {
                              breakUp15s();
                          }
                      } else {
                        //socket.emit('sent', 'sukses');
                              
                        blast.statusBlast("sukses");

                          // DESTROY SETELAH BLAST KELAR
                      }

                    } else {
                      //alert(x.pesan);
                    }
                })
                .catch(error => {
                  //var error = error.response.status;
                  //this.error(error);

                  
                  dataLog.boxResume = true;


                });;

            }, 5000);
        }

        var stat15Jumlah = 4;
        var stat15sKirim = 0;

        const breakUp15s = function() {
            //.emit('sent', "pause");
            blast.statusBlast("pause");

            stat15sKirim = 0;
            setTimeout(function(){ 
                kirimPesan(); 
                //socket.emit('sent', "restart");
                blast.statusBlast("restart");
            }, 15000);
        }

        console.log("gas kirim ");
        kirimPesan();
      },
      statusBlast(val) {
        if(val == "sukses") {
          // SELESAI KESELURUHAN
          blast.data.pesanKirimPause = "Pesan berhasil Dikirim";
          blast.data.modalWAFooter = true;
          blast.data.modalWAPasswordFooter = true;
          theGet.data.checkedNames = [];
          //this.blast.data.selectWaBlast = false;
        } else if (val == "start") {
          blast.data.pesanKirimPause = "Mulai Mengirim Pesan..";
        } else if (val == "restart") {
          blast.data.pesanKirimPause = "Lanjoet Mengirim Pesan...";
        } else if (val == "pause") {
          blast.data.pesanKirimPause = "Di Pause 15s, biar ga ke blokir akak No WhatsAppnya";
        } else {
          blast.data.pesanKirim = val;
          blast.data.progress = blast.data.progress + 1;

          let logD = {
            teks:val
          }
          dataLog.logProsesWa.unshift(logD);
        }
      },
      password() {
        console.log(theGet.data.checkedNames.length);
        if (theGet.data.checkedNames.length == 0) {
          return false;
        }

        this.data.modalWAPassword = true;
        //console.log(JSON.stringify(theGet.data.checkedNames))

        //console.log("kirimPasswordPelanggan()");
        //console.log(this.sesi);
      },
      PasswordConfirm() {

        this.data.totalProgress = theGet.data.checkedNames.length;

        var userid = null;

        for (let i = 0; i < this.data.totalProgress; i++) {
          if (userid == null) {
            userid = theGet.data.checkedNames[i]["uid"];
          } else {
            userid = userid + "," + theGet.data.checkedNames[i]["uid"];
          }
        }

        // sukses reset password
        if (this.data.waPass == '') {
          alert('Kok kosong teksnya?');
          return;
        }
        var str = this.data.waPass; //.replace(/(?:\r|\n|\r\n)/g, '%0a');
        //str = str.replace(/\s/g, '%20');
              
        // CEK WA LOKALAN
        if(sessionStorage.getItem("walokallogin") == "kosong") {
          // CEK WA SERVER
          if (sessionStorage.getItem('walogin') == 'kosong') {
            alert('Anda belum scan wa');
            return;
          }
          if (sessionStorage.getItem('walogin') == 'belum') {
            alert('Anda belum scan wa');
            return false;
          }
        } else {
          if(sessionStorage.getItem("walokallogin") != "siap") {
            alert('Wa Bot lokal belum siap');
            return false;
          }
        }

        // WA LOKAL SIAP
        let pakaiWA = "server";
        if(data.blBuka == "siap") {
          pakaiWA = "lokal";
        }

        if (this.data.appnameedit != '') {
          if (this.data.applinkedit == "") {
            alert('Link App tidak boleh kosong');
            return;
          }
          
          str = str.replace("[[appnamex]]", this.data.appnameedit);
          str = str.replace("[[applinkx]]", this.data.applinkedit);
        } else {
          str = str.replace("[[appnamex]]", this.data.appname);
          str = str.replace("[[applinkx]]", this.data.applink);
        }

        str = str.replace("[[rtrw]]", this.data.namaQ);
        
        this.data.progress = 0;

        //this.data.modalWAPasswordProgress = true; // awalnya ini
        this.data.modalWA = true;

        //console.log(JSON.stringify(theData));

        var datax = {
          token: 'TangTung '+sessionStorage.getItem('myToken'),
          ids: userid
        }
        
        var apiUrl = inter.PelangganResetPassMulti(); // hapusUser
        myGlobal.call(datax,apiUrl).then(x => {
          if (x.status) {
            //console.log(JSON.stringify(x.data));
            //console.log(theData);

            str = str.replace("[[password]]", x.data);

            var theData = {
              data: JSON.stringify({
                  data: theGet.data.checkedNames,
                  pesan: "Bebas sih ini",
                  status: true
              }),
              token: null,
              pesanwa: str
              //bulan: this.bulanBase+ ' ' + this.tahunBase,
              //namaKu: sessionStorage.getItem('admin'),
              //wateks: sessionStorage.getItem('wateks'),
              //ppn: sessionStorage.getItem('PPN')
            }

            //data.socket.emit('kirim-blast-password', theData);
            if(pakaiWA == "server") {
              data.socket.emit('kirim-blast-password', theData);
            } else {

              dataLog.passwordTeks = str;

              
              blast.lokalTagihanPassword(theData);
            }
          } else {
            //alert(x.pesan);
          }
        })

      },
      pengumuman(buat) {
        console.log(theGet.data.checkedNames.length);
        if (theGet.data.checkedNames.length == 0) {
          return false;
        }
        //console.log(JSON.stringify(theGet.data.checkedNames))

        if (buat == "isolir") {
          this.data.pengumumanTeks = "Maaf Internet anda Terisolir. Segera lakukan pembayaran ya :)"
        }

        this.data.modalWABlast = true;
      },
      testTextToURL() {
        let pakaiWA = "server";
        // alert("status bot lokalan "+sessionStorage.getItem("walokallogin"));

        dataLog.logProsesWa = [];


        var str = this.data.pengumumanTeks; //.replace(/(?:\r|\n|\r\n)/g, '%0a');
        //str = str.replace(/\s/g, '%20');

        if (str == '') {
          alert('Kok kosong teksnya?');
          return;
        }
              
        // CEK WA LOKALAN
        if(sessionStorage.getItem("walokallogin") == "kosong") {
          // CEK WA SERVER
          if (sessionStorage.getItem('walogin') == 'kosong') {
            alert('Anda belum scan wa');
            return;
          }
          if (sessionStorage.getItem('walogin') == 'belum') {
            alert('Anda belum scan wa');
            return false;
          }
        } else {
          if(sessionStorage.getItem("walokallogin") != "siap") {
            alert('Wa Bot lokal belum siap');
            return false;

            /*

          } else {
            // sudah siap
            pakaiWA = "lokal";

            console.log("kok kesini");

            */

          }
        }
        
        console.log("blbuka "+data.blBuka);

        // WA LOKAL SIAP
        if(data.blBuka == "siap") {
          pakaiWA = "lokal";
        }

        console.log("pakai apa "+pakaiWA);
        
        this.data.progress = 0;

        this.data.modalWA = true;

        this.data.totalProgress = theGet.data.checkedNames.length;
        
        var theData = {
          data: JSON.stringify({
            data: theGet.data.checkedNames,
            pesan: "Bebas sih ini",
            status: true
          }),
          token: "", //this.sesi,
          pesanwa: str
          //bulan: this.bulanBase+ ' ' + this.tahunBase,
          //namaKu: sessionStorage.getItem('admin'),
          //wateks: sessionStorage.getItem('wateks'),
          //ppn: sessionStorage.getItem('PPN')
        }
        //console.log(JSON.stringify(theData));

        if(pakaiWA == "server") {
          data.socket.emit('kirim-blast-notemplate', theData);
        } else {
          dataLog.checkedNamesResume = theGet.data.checkedNames;

          dataLog.pengumumanTeks = str;

          blast.lokalTagihanNoTemplate(theData);
        }
      },

    }

    const filter = {
      data: reactive({
        area: [],
        paket: [],
        admin: [],
        modalPaket: false,
        modalArea: false,
        modalAdmin: false,
        areaPilih: '',
        areaPilihNama: '',
        filterCustomBoxTagihan: false,
        filterAreaTagihan: false,
        tglTagihan: '',

        showAll: "belum", // jika false 
      }),
      cariCustomTanggal() {
        theGet.data.Title = "Pelanggan By Tanggal "+moment(filter.data.tglTagihan).format('DD')+" - Belum Bayar";

        var datax = new FormData();
        datax.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
        datax.append('bulan', "0");
        datax.append('tahun', "0");
        datax.append('type', "belum");
        datax.append('area', null);
        datax.append('tanggal', moment(filter.data.tglTagihan).format('YYYY-MM-DD'));
        
        var apiUrl = inter.PelangganListCari();
        myGlobal.call(datax,apiUrl).then(x => {
          //console.log(JSON.stringify(x));
          if (x.status == true) {
            theGet.data.ListPelanggan = x.data;
          } else {
            //alert(x.pesan);
            theGet.data.ListPelanggan = null;
          }
        })
      },
      customFormatter (date) {
        return moment(date).format('YYYY-MM-DD');
      },
      getAdmin() {
        // for filter
        var data = {
          token: 'TangTung '+sessionStorage.getItem('myToken'),
          is: 'tagih'
        }
        
        var apiUrl = inter.AdminList();
        myGlobal.call(data,apiUrl).then(x => {
          //console.log(JSON.stringify(x))
          if (x.status) {
            this.data.admin = x.data;
          } else {
            //alert(x.pesan);
          }
        })
      },
      cariByAdmin(area,nama) {
        theGet.data.Title = "Pelanggan By Admin "+nama+" - Belum Bayar";

        filter.data.modalAdmin = false;
        var datax = filter.data;

        var data = new FormData();
        data.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
        data.append('bulan', "0");
        data.append('tahun', sessionStorage.getItem('tahunBase'));
        data.append('type', datax.showAll);
        data.append('area', area);
        data.append('by', "area");
        
        var apiUrl = inter.PelangganListCari();
        myGlobal.call(data,apiUrl).then(x => {
          //console.log(JSON.stringify(x));

          this.data.modalArea = false;
          this.data.areaPilih = "";
          this.data.areaPilihNama = "";

          if (x.status) {
            theGet.data.ListPelanggan = x.data;
            //this.totalBelum = x.pesan;
            
          } else {
            //alert(x.pesan);
            theGet.data.ListPelanggan = null;
            this.textCariPelanggan = x.pesan;
          }
        })
      },
      getPaket() {
        // for filter
        var data = {
          token: 'TangTung '+sessionStorage.getItem('myToken')
        }
        
        var apiUrl = inter.ListPaket();
        myGlobal.call(data,apiUrl).then(x => {
          //console.log(JSON.stringify(x))
          if (x.status) {
            this.data.paket = x.data;
          } else {
            //alert(x.pesan);
          }
        })
      },
      cariByPaket(id,nama) {
        this.data.modalPaket = false;
        theGet.data.Title = "Pelanggan Paket "+nama+" - Belum Bayar";
        
        var datax = filter.data;

        this.loading = true;
        var data = new FormData();
        data.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
        data.append('bulan', "0");
        data.append('tahun', sessionStorage.getItem('tahunBase'));
        data.append('type', datax.showAll);
        data.append('paket', id);
        data.append('by', "paket");
        
        var apiUrl = inter.PelangganListCari();
        myGlobal.call(data,apiUrl).then(x => {
          //console.log(JSON.stringify(x));

          this.data.modalArea = false;
          this.data.areaPilih = "";
          this.data.areaPilihNama = "";

          if (x.status) {
            theGet.data.ListPelanggan = x.data;
            //this.totalBelum = x.pesan;
            
          } else {
            //alert(x.pesan);
            theGet.data.ListPelanggan = null;
            this.textCariPelanggan = x.pesan;
          }
        })
      
      },
      cariCustom() {
        theGet.data.Title = "Pelanggan Filter Area - Belum Bayar";

        var datax = filter.data;

        this.loading = true;
        var data = new FormData();
        data.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
        data.append('bulan', "0");
        data.append('tahun', sessionStorage.getItem('tahunBase'));
        data.append('type', datax.showAll);
        data.append('area', this.data.areaPilih);
        data.append('by', "area");
        
        var apiUrl = inter.PelangganListCari();
        myGlobal.call(data,apiUrl).then(x => {
          //console.log(JSON.stringify(x));

          this.data.modalArea = false;
          this.data.areaPilih = "";
          this.data.areaPilihNama = "";

          if (x.status) {
            theGet.data.ListPelanggan = x.data;
            //this.totalBelum = x.pesan;
            
          } else {
            //alert(x.pesan);
            theGet.data.ListPelanggan = null;
            this.textCariPelanggan = x.pesan;
          }
        })
      }
    }

    const theGet = {
      data: reactive({
        ListPelanggan: [],
        checkedNames: [],
        Title: "Semua Pelanggan",

        stat: '', // default all
        telat: 'tidak', // default tidak
        
        page: 0,
        pageStat: 0,
        loadmoreState: 'all'
      }),
      pilihSemua() {
        this.data.checkedNames = [];
        for (let i = 0; i < this.data.ListPelanggan.length; i++) {
          this.data.checkedNames.push(this.data.ListPelanggan[i].user);
        }
        //console.log(JSON.stringify(this.data.checkedNames));
      },
      allPelanggan() {
        this.data.Title = "Semua Pelanggan";

        this.data.stat = "all";

        var data = new FormData();
        data.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
        data.append('type', "all");
        data.append('bulan', "0");
        data.append('page', "all");
        //data.append('telat', "iya");
        data.append('tahun', myGlobal.getTahunNow());
        
        var apiUrl = inter.PelangganList();
        myGlobal.call(data,apiUrl).then(x => {
          //console.log(JSON.stringify(x));

          this.loading = false;
          if (x.status) {
            this.data.ListPelanggan = x.data;
          } else {
            //alert(x.pesan);
            this.pageStat = 999;
          }
        })
      },
      belumBayar() {
        this.data.Title = "Pelanggan Belum Bayar";

        this.data.stat = "belum";

        var data = new FormData();
        data.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
        data.append('type', "belum");
        data.append('bulan', "0");
        data.append('page', "all");
        //data.append('telat', "iya");
        data.append('tahun', myGlobal.getTahunNow());
        
        var apiUrl = inter.WaPelangganList();
        myGlobal.call(data,apiUrl).then(x => {
          //console.log(JSON.stringify(x));

          this.loading = false;
          if (x.status) {
            this.data.ListPelanggan = x.data;
          } else {
            //alert(x.pesan);
            this.pageStat = 999;
          }
        })
      },
      Isolir() {
        this.data.Title = "Pelanggan Belum Bayar";

        this.data.stat = "belum";

        var data = new FormData();
        data.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
        data.append('type', "isolir");
        data.append('bulan', "0");
        data.append('page', "all");
        //data.append('telat', "iya");
        data.append('tahun', myGlobal.getTahunNow());
        
        var apiUrl = inter.PelangganList();
        myGlobal.call(data,apiUrl).then(x => {
          //console.log(JSON.stringify(x));

          this.loading = false;
          if (x.status) {
            this.data.ListPelanggan = x.data;
          } else {
            //alert(x.pesan);
            this.pageStat = 999;
          }
        })
      },
      pelangganTelat() {
        this.data.Title = "Pelanggan Telat";

        this.stat = "all";

        var data = new FormData();
        data.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
        data.append('type', "belum");
        data.append('bulan', "0");
        data.append('page', "all");
        data.append('telat', "iya");
        data.append('tahun', myGlobal.getTahunNow());
        
        var apiUrl = inter.PelangganList();
        myGlobal.call(data,apiUrl).then(x => {
          //console.log(JSON.stringify(x));

          this.loading = false;
          if (x.status) {
            this.data.ListPelanggan = x.data;
          } else {
            this.data.ListPelanggan = null;
            //alert(x.pesan);
            this.pageStat = 999;
          }
        })
      },
      tunggakan(x) {
        var d = new Date();
        var n = d.getMonth();
        var bulan = n + 1;
        if (sessionStorage.getItem('bulanIdBase') != "0") {
          bulan = sessionStorage.getItem('bulanIdBase');
        }
        // console.log("bulan : " + bulan + " - " +sessionStorage.getItem('bulanIdBase'));

        var months;
        var lastbayar = new Date(x);
        var today = new Date(sessionStorage.getItem('tahunBase')+"-"+bulan+"-01");
        //var today = new Date();
        months = (today.getFullYear() - lastbayar.getFullYear()) * 12;
        months -= lastbayar.getMonth();
        months += today.getMonth();
        return months <= 0 ? 0 : months;
      },
      bulanIni() {
        var newDate = new Date();
        var bulanNama = ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'];
        //var realBulan = bulanNama[parseInt(newDate.getMonth())]+' '+newDate.getFullYear();
        var realBulan = "";
        return realBulan;
      },
      coba(x) {
          const tunggakan = function(x) {
              var months;
              var lastbayar = new Date(x);
              var today = new Date();
              months = (today.getFullYear() - lastbayar.getFullYear()) * 12;
              months -= lastbayar.getMonth();
              months += today.getMonth();
              return months <= 0 ? 0 : months;
          }

          var bulanNama = ['Jan', 'Feb', 'Mar', 'Apr', 'Mei', 'Jun', 'Jul', 'Ags', 'Sept', 'Okt', 'Nov', 'Des'];
          var lastbayar = x; //userD.lastbayar;
          var jumlahnunggak = parseInt( tunggakan(lastbayar) );
          var realBulan = "";
            if (jumlahnunggak < 1) {
                var newDate = new Date();
                realBulan = bulanNama[parseInt(newDate.getMonth())]+' '+newDate.getFullYear();
            } else {
                for (let i = 0; i < jumlahnunggak; i++) {
                    var dateSekarang = new Date();
                    var newDate = new Date(dateSekarang.setMonth(dateSekarang.getMonth() - i ));
                    if (realBulan == "") {
                      realBulan = bulanNama[parseInt(newDate.getMonth())]+' '+newDate.getFullYear();
                    } else {
                      realBulan = bulanNama[parseInt(newDate.getMonth())]+' '+newDate.getFullYear() + ", " + realBulan ;
                    }
                } 
            }

          console.log(realBulan);
      },

      /// SEMUA DIATAS ITU SAMPAH 
      
      getArea() {
        // for filter
        var data = new FormData();
        data.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
        data.append('type', "all");
        data.append('bulan', sessionStorage.getItem('bulanIdBase'));
        
        var apiUrl = inter.ListArea();
        myGlobal.call(data,apiUrl).then(x => {
          //console.log(JSON.stringify(x));
          if (x.status) {
            filter.data.area = x.data;
          } else {
            //alert(x.pesan);
          }
        })
      },
      pilihArea(id,nama) {
        filter.areaId = id;
        filter.areaName = nama;
        //this.modalArea = false;
        //this.modalArea = false;

        if (filter.data.areaPilih != "") {
          if (filter.data.areaPilih.indexOf(id) > -1)
          {
            //alert("hello found inside your_string");
          } else {
            filter.data.areaPilih = filter.data.areaPilih+","+id;
            filter.data.areaPilihNama = filter.data.areaPilihNama+","+nama;
          }
        } else {
          filter.data.areaPilih = id;
          filter.data.areaPilihNama = nama;
        }

        //console.log(this.data.areaPilih);

      },

      pelanggan() {
        if (theGet.data.pageStat == 999) {
          return false;
        }

        theGet.data.Title = "Semua Pelanggan";

        var data = new FormData();
        data.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
        data.append('type', "all");
        data.append('bulan', "0");
        data.append('page', theGet.data.page);
        data.append('tahun', myGlobal.getTahunNow());
        
        var apiUrl = inter.WaPelangganList();
        myGlobal.call(data,apiUrl).then(x => {
          //console.log(JSON.stringify(x));

          this.loading = false;
          if (x.status) {
            if (theGet.data.ListPelanggan.length > 0) {
              var data = x.data;
              var i;
              for (i = 0; i < data.length; i++) {
                theGet.data.ListPelanggan.push(data[i]);
              }
            } else {
              theGet.data.ListPelanggan = x.data;
            }
          } else {
            //alert(x.pesan);
            alert("Tidak ada Data lagi");
            theGet.data.pageStat = 999;
          }
        })
      },
      loadmorePelanggan() {
        if (theGet.data.loadmoreState == 'all') {
          theGet.data.page = theGet.data.page + 1;
          //console.log(theGet.data.page);
          theGet.pelanggan();
        } else if (theGet.data.loadmoreState == 'all-filter') {
          theGet.data.page = theGet.data.page + 1;
          theGet.pelangganFilter();
        } else if (theGet.data.loadmoreState == 'isolir') {
          theGet.data.page = theGet.data.page + 1;
          theGet.pelangganIsolir();
        } else {
          theGet.data.page = theGet.data.page + 1;
          theGet.pelangganBelum();
          //console.log("belum");
        }

        //console.log(theGet.data.loadmoreState);
      },
      pelangganFilter() {
        if (theGet.data.pageStat == 999) {
          return false;
        }

        if (theGet.data.loadmoreState == 'belum-telat') {
          theGet.data.Title = "Belum Bayar dan Telat";
        } else {
          theGet.data.Title = "Belum Bayar";
        }

        var data = new FormData();
        data.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
        data.append('type', "all");
        data.append('bulan', sessionStorage.getItem('bulanIdBase'));
        data.append('page', theGet.data.page);
        data.append('tahun', sessionStorage.getItem('tahunBase'));
        if (filter.data.tglTagihan != "") {
          data.append('tanggal', moment(filter.data.tglTagihan).format('DD'));
        }
        if (filter.data.areaPilih != "") {
          data.append('area', filter.data.areaPilih);
        }
        if (theGet.data.loadmoreState == "belum-telat") {
          data.append('telat', "iya");
        }
        
        //console.log(filter.data.areaPilih);
        
        var apiUrl = inter.WaPelangganList();
        myGlobal.call(data,apiUrl).then(x => {
          //console.log(JSON.stringify(x));

          this.loading = false;
          if (x.status) {
            if (theGet.data.ListPelanggan.length > 0) {
              var data = x.data;
              var i;
              for (i = 0; i < data.length; i++) {
                theGet.data.ListPelanggan.push(data[i]);
              }
            } else {
              theGet.data.ListPelanggan = x.data;
            }
          } else {
            //alert(x.pesan);
            alert("Tidak ada Data lagi");
            theGet.data.pageStat = 999;
          }
        })
      },
      pelangganBelum() {
        if (theGet.data.pageStat == 999) {
          return false;
        }

        if (theGet.data.loadmoreState == 'belum-telat') {
          theGet.data.Title = "Belum Bayar dan Telat";
        } else {
          theGet.data.Title = "Belum Bayar";
        }

        var data = new FormData();
        data.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
        data.append('type', "belum");
        data.append('bulan', sessionStorage.getItem('bulanIdBase'));
        data.append('page', theGet.data.page);
        data.append('tahun', sessionStorage.getItem('tahunBase'));
        if (filter.data.tglTagihan != "") {
          data.append('tanggal', moment(filter.data.tglTagihan).format('DD'));
        }
        if (filter.data.areaPilih != "") {
          data.append('area', filter.data.areaPilih);
        }
        if (theGet.data.loadmoreState == "belum-telat") {
          data.append('telat', "iya");
        }
        
        //console.log(filter.data.areaPilih);
        
        var apiUrl = inter.WaPelangganList();
        myGlobal.call(data,apiUrl).then(x => {
          //console.log(JSON.stringify(x));

          this.loading = false;
          if (x.status) {
            if (theGet.data.ListPelanggan.length > 0) {
              var data = x.data;
              var i;
              for (i = 0; i < data.length; i++) {
                theGet.data.ListPelanggan.push(data[i]);
              }
            } else {
              theGet.data.ListPelanggan = x.data;
            }
          } else {
            //alert(x.pesan);
            alert("Tidak ada Data lagi");
            theGet.data.pageStat = 999;
          }
        })
      },
      pelangganIsolir() {
        if (theGet.data.pageStat == 999) {
          return false;
        }

        theGet.data.Title = "Pelanggan Isolir";

        var data = new FormData();
        data.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
        data.append('type', "isolir");
        data.append('bulan', sessionStorage.getItem('bulanIdBase'));
        data.append('page', theGet.data.page);
        data.append('tahun', sessionStorage.getItem('tahunBase'));

        if (filter.data.tglTagihan != "") {
          data.append('tanggal', moment(filter.data.tglTagihan).format('DD'));
        }

        if (filter.data.areaPilih != "") {
          data.append('area', filter.data.areaPilih);
        }

        if (theGet.data.loadmoreState == "belum-telat") {
          data.append('telat', "iya");
        }
        
        var apiUrl = inter.WaPelangganList();
        myGlobal.call(data,apiUrl).then(x => {
          //console.log(JSON.stringify(x));

          this.loading = false;
          if (x.status) {
            if (theGet.data.ListPelanggan.length > 0) {
              var data = x.data;
              var i;
              for (i = 0; i < data.length; i++) {
                theGet.data.ListPelanggan.push(data[i]);
              }
            } else {
              theGet.data.ListPelanggan = x.data;
            }
          } else {
            //alert(x.pesan);
            alert("Tidak ada Data lagi");
            theGet.data.pageStat = 999;
          }
        })
      },
    }
    return {
      data, 
      theGet,
      myGlobal,
      filter,
      blast,
      wa,
      dataLog
    }
  },
  mounted () {
    document.title = "WhatsApp BOT";

    this.theGet.data.stat = "all";

    this.blast.data.namaQ = sessionStorage.getItem('admin');

    //this.theGet.data.loadmoreState = "all";
    this.theGet.pelanggan();
    this.theGet.getArea();

    //this.wa.getSesi();
    //this.filter.getArea();
    //this.filter.getPaket();
    //this.filter.getAdmin();

    this.data.socket = this.$socket;

    //this.theGet.coba("2023-09-01");

    
    if (sessionStorage.getItem('tipe') != null) {
      this.data.tipe = sessionStorage.getItem('tipe');
    }

    console.log(this.blast.data.applink);

    let webadmin = loginFor;
    if(webadmin == "aplikabeat") {
      this.blast.data.applink = "https://aplikabeat.com";
    }

    console.log(webadmin);
    console.log(this.blast.data.applink);

    if(sessionStorage.getItem("wabot") != null) {
      let botMetode = sessionStorage.getItem("wabot");
      this.data.pakaiWabotSimpan = botMetode;
      this.data.pakaiWabot = botMetode;
    }

  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.modal {
	display: inherit;
}
.tutorBox {
  padding: 10px; border-radius: 10px; background-color: #e1e1e1;
}
.script-box {
  background-color: #f6f6f6; border-left: 5px solid #009ee0; padding: 17px; text-align: left;display: inline-block;;
}
.listing p {
  display: block;
}
.footer-check {
  z-index: 999;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #fff;
}
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.5);
}
</style>



// WEBPACK FOOTER //
// src/components/wa/main.vue